import { SOURCE_SAMPLE } from "constants/sample";

export const SampleSourceOptions = [
  { label: "Spotify", value: SOURCE_SAMPLE.SPOTIFY },
  { label: "Manually", value: SOURCE_SAMPLE.MANUALLY },
];
